var lists_default = {
  "fontElementMap": "tKjmr",
  "orderedlist": "NNPMD",
  "bulletedlist": "bJAXr",
  "listItem": "_9b43l"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
